// ISDP CUSTOM: custom scaffolder field extensions (Doc Author Starter Kit). Registered in App.tsx as
// <ScaffolderFieldExtensions> children of <ScaffolderPage>. Template contract:
//   ui:field: DocTypePicker  → string (quick | guide | bilingual)
//   ui:field: AuthorProfile  → { name: string, email: string }
//   ui:field: AdoRepoTarget  → { project: string, repoName: string }   (PAT from secrets.adoPat)
import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { AuthorProfileField, authorProfileValidation } from './AuthorProfileField';
import {
  AdoRepoTargetField,
  adoRepoTargetValidation,
  type AdoRepoTargetUiOptions,
} from './AdoRepoTargetField';
import { DocTypePickerField, docTypePickerValidation } from './DocTypePickerField';
import type { AdoRepoTargetValue, AuthorProfileValue } from './fieldHelpers';
import './fields.css';

export const DocTypePickerFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension<string>({
    name: 'DocTypePicker',
    component: DocTypePickerField,
    validation: docTypePickerValidation,
    schema: { returnValue: { type: 'string' } },
  }),
);

export const AuthorProfileFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension<AuthorProfileValue>({
    name: 'AuthorProfile',
    component: AuthorProfileField,
    validation: authorProfileValidation,
    schema: {
      returnValue: {
        type: 'object',
        required: ['name', 'email'],
        properties: { name: { type: 'string' }, email: { type: 'string' } },
      },
    },
  }),
);

export const AdoRepoTargetFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension<AdoRepoTargetValue, AdoRepoTargetUiOptions>({
    name: 'AdoRepoTarget',
    component: AdoRepoTargetField,
    validation: adoRepoTargetValidation,
    schema: {
      returnValue: {
        type: 'object',
        required: ['project', 'repoName'],
        properties: { project: { type: 'string' }, repoName: { type: 'string' } },
      },
      uiOptions: {
        type: 'object',
        properties: {
          secretKey: { type: 'string', description: "Template secret holding the ADO PAT (default 'adoPat')." },
          titleField: { type: 'string', description: "formData key the default repo name derives from (default 'title')." },
        },
      },
    },
  }),
);
